import { DashboardIconClipBoard } from '@hr/common/icons'
import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getAllPersons } from '../../actions/persons/personsgetall'
import { LoadingContainer } from '../../common/loaders/loadingcontainer'
import { jsError, localized } from '../../common/utils'
import { personsSelector } from '../../reducers'

export function NewContractsStarting() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const persons = useSelector(personsSelector)

	const startKey = 'newContractsStarting_startDate'
	const endKey = 'newContractsStarting_endDate'

	const today = new Date().toISOString().split('T')[0]

	const [data, setData] = useState()

	const [startDate, setStartDate] = useState(() => {
		return (
			localStorage.getItem(startKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().split('T')[0]
		)
	})

	const [endDate, setEndDate] = useState(() => {
		return (
			localStorage.getItem(endKey) ||
			new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().split('T')[0]
		)
	})

	useEffect(() => {
		const fetchPersons = async () => {
			try {
				dispatch(getAllPersons())
			} catch (err) {
				jsError(err)
			}
		}
		fetchPersons()
	}, [dispatch])

	useEffect(() => {
		localStorage.setItem(startKey, startDate)
	}, [startDate])

	useEffect(() => {
		localStorage.setItem(endKey, endDate)
	}, [endDate])

	const getFormOfSalaryText = (formOfSalary) => {
		switch (formOfSalary) {
			case 1:
				return t('MonthlySalary', 'Kuukausipalkka')
			case 2:
				return t('HourlySalary', 'Tuntipalkka')
			default:
				return '-'
		}
	}

	useEffect(() => {
		if (!persons) return

		const start = new Date(startDate)
		start.setHours(0, 0, 0, 0)

		const end = new Date(endDate)
		end.setHours(23, 59, 59, 999)

		const filteredPersons = persons.filter((person) => {
			const contractStartDate = person.employmentDetails?.contractStartDate

			if (!contractStartDate) return false

			const startDateObj = new Date(contractStartDate)

			return startDateObj >= start && startDateObj <= end
		})

		const tableData = filteredPersons
			.map((person) => ({
				personName: person.name,
				contractStartDate: new Date(person.employmentDetails.contractStartDate),
				salaryDetails: person.salaryDetails,
				payGroup: person.controlDetails?.payGroup,
			}))
			.sort((a, b) => a.contractStartDate - b.contractStartDate)

		setData(tableData)
	}, [persons, startDate, endDate])

	if (!data) {
		return <LoadingContainer />
	}

	return (
		<>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '8px',
					}}
				>
					<span className="starting-employments-icon">
						<DashboardIconClipBoard />
					</span>

					<h4 style={{ margin: 0 }}>{t('NewContractsStarting', 'Uusien työsopimusten alkaminen')}</h4>
				</div>

				<div style={{ display: 'flex', gap: '10px' }}>
					<input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />

					<input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
				</div>
			</div>

			{data.length ? (
				<div style={{ overflowX: 'auto' }}>
					<Table>
						<thead>
							<tr>
								<th>{t('Person', 'Henkilö')}</th>
								<th>{t('ContractStartDate', 'Alkupäivä')}</th>
								<th>{t('FormOfSalary', 'Palkkausmuoto')}</th>
								<th>{t('PayGroup', 'Maksuryhmä')}</th>
							</tr>
						</thead>

						<tbody>
							{data.map((row) => (
								<tr key={row.personName}>
									<td>{row.personName}</td>

									<td>{row.contractStartDate.toLocaleDateString(localized.resolvedLanguage)}</td>

									<td>{getFormOfSalaryText(row.salaryDetails?.formOfSalary)}</td>

									<td>{row.payGroup ?? '-'}</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			) : (
				<p>({t('NoStartingContracts', 'Ei alkavia työsopimuksia')})</p>
			)}
		</>
	)
}
